import template from './myLoans.html';
import controller from './myLoans.controller';
import './myLoans.scss';

let myLoansComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<'
  },
  template,
  controller
};

export default myLoansComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoans.component.js